import React from "react";
import {
  Row,
  Col,
  ListGroupItem,
  Panel,
  Grid,
  ListGroup
} from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";
import PersonalDetailsForm from "./form";
import { recordPayment } from "../../../actions/basket";
import "./styles.css";
import { PayPalButton } from "react-paypal-button-v2";

class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { paypalLaded: false, proceesingPayment: false };
    
  }
  
 
  render() {
    const paypalVersion = localStorage.getItem("ppv");
    let firstName = "";
    let email = "";
    if (this.props.basketData.transfers[0].forename) {
      firstName = this.props.basketData.transfers[0].forename
        .toLowerCase()
        .replace(/(?:_| |\b)(\w)/g, function(str, p1) {
          return p1.toUpperCase();
        });
    }
    const lastName = this.props.basketData.transfers[0].surname
      .toLowerCase()
      .replace(/(?:_| |\b)(\w)/g, function(str, p1) {
        return p1.toUpperCase();
      });
    if (this.props.basketData.transfers[0].email) {
      email = this.props.basketData.transfers[0].email
        .toLowerCase()
        .replace(/(?:_| |\b)(\w)/g, function(str, p1) {
          return p1;
        });
    }

    const initialValues = {
      validMonths: "January",
      validYears: 2017,
      country: "GB",
      firstName,
      lastName
    };

    const { outboundData, inboundData } = this.props;

    const handleSubmit = val => {
      //console.log(val);
    };
    const createOrder = (data, actions) => {
      return actions.order.create({
        payer: {
          address: {
            country_code: "GB"
          },
          email_address: email
        },
        shipping_preference: "NO_SHIPPING",
        shipping_type: "PICKUP",
        application_context: {
          shipping_preference: "NO_SHIPPING"
        },
        purchase_units: [
          {
            reference_id: this.props.paymentRef,
            custom_id: this.props.paymentRef,
            amount: {
              currency_code: this.props.money.currency[0],
              value: (this.props.money.totalToPay / 100).toFixed(2).toString()
            }
          }
        ]
      });
    };
    const onSuccess = (details, data) => {
      // The payment is complete!
      // You can now show a confirmation message to the customer
      this.setState({ proceesingPayment: true });
      let transactionId =
        details.purchase_units[0].payments.captures[0].id.length > 0
          ? details.purchase_units[0].payments.captures[0].id
          : "";
      let isString =
        typeof transactionId === "string" || transactionId instanceof String;
      if (isString && transactionId.length <= 17) {
        const obj = {
          method: "paypal",
          currency: this.props.money.currency[0],
          amount: this.props.money.totalToPay,
          result: true,
          error: "",
          correlation: "",
          transaction: transactionId,
          paymentRef: this.props.paymentRef
        };
        this.props.recordPayment(this.props.basketId, obj).then(() => {
          this.setState({ proceesingPayment: false });
        });
      }
    };

    const onError = err => {
      // The main Paypal's script cannot be loaded or somethings block the loading of that script!
      const obj = {
        method: "paypal",
        currency: this.props.money.currency[0],
        amount: this.props.money.totalToPay,
        result: false,
        error: err.message,
        correlation: "blah",
        transaction: "blah",
        paymentRef: this.props.paymentRef
      };
      this.props.recordPayment(this.props.basketId, obj);
      // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
      // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    };

    const payment = (data, actions) => {
      return actions.payment.create({
        payment: {
          intent: "sale",
          payer: {
            payment_method: "paypal"
          },
          transactions: [
            {
              amount: {
                total: (this.props.money.totalToPay / 100)
                  .toFixed(2)
                  .toString(),
                currency: this.props.money.currency[0]
              },
              description: "Ski Lifts Transfer",
              custom: this.props.bookingId
            }
          ],
          note_to_payer: "Contact us for any questions on your order."
        }
      });
    };

    let env = process.env.REACT_APP_PAYPAL_ENV; // you can set here to 'production' for production

    const client = {
      sandbox: process.env.REACT_APP_PAYPAL_SANBOX_KEY,
      production: process.env.REACT_APP_PAYPAL_PRODUCTION_KEY
    };
    const paypal_key =
      env === "production" ? client.production : client.sandbox;
    const paypalOptions = {
      clientId: paypal_key,
      currency: this.props.money.currency[0],
      disableFunding:
        "card,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo",
      commit:false,
      locale: "en_GB"
    };
    

    const isItLoading = () => (!this.state.paypalLaded ? "hideTag" : null);
    const loadPayment = () => {
      return paypalVersion !== "2" ? (
        <PersonalDetailsForm
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          info={this.props.info}
          lastBlurredField={this.props.lastBlurredField}
          validatePayment={this.props.validatePayment}
          lastBlurredState={this.props.lastBlurredState}
          basketId={this.props.basketId}
        />
      ) : (
        <div className={`paypal-button v2 ${isItLoading()}`}>
          <div class="cc-img"></div>

          <PayPalButton
            className="paypal-button"
            onError={err => onError(err)}
            onApprove={(data, action) => payment(data, action)}
            onSuccess={(details, data) => onSuccess(details, data)}
            currency={this.props.money.currency[0]}
            createOrder={(data, action) =>
              createOrder(data, action)
            }
            onRendered={() => {
              this.setState({ paypalLaded: true });
            }}
            style={{
              size: "responsive",
              shape: "rect",
              label: "checkout",
              tagline: false
            }}
            options={paypalOptions}
          />

      <p style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
        PayPal securely handle our payments. Simply select the PayPal Checkout button where you can use your debit or credit card, or you can choose to login to your PayPal account to pay for your transfer.
      </p>

         
        </div>
      )
    }

    return (
      <div>
        {paypalVersion === "2" &&
        localStorage.getItem("converted") === "true" &&
        (this.state.proceesingPayment || !this.state.paypalLaded) ? (
          <div className="spinner">
            {" "}
            <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" />
          </div>
        ) : null}
        <Grid>
          <Col>
            <Panel>
              <Panel.Heading>
                <h3 className="centered">
                  {paypalVersion === "2" && "Payment"}
                </h3>
              </Panel.Heading>
              <Panel.Body>
                <Col xs={12} md={6} className="text-center ">
                <h4 >
                <strong> {paypalVersion !== "2"
                    ? "Personal Details"
                    : "Payment Details"}
                    </strong> 
                </h4>
                  {localStorage.getItem("converted") === "false" ? (
                    <div>
                      Something went wrong, please <br />
                      <a
                        className="btn btn-primary margin10"
                        href={"/quote/" + localStorage.getItem("guid")}
                      >
                        Try Again
                      </a>
                      <br /> or <br />
                      <a
                        className="btn btn-primary margin10"
                        href="https://www.ski-lifts.com/contact-us/"
                      >
                        Contact Us
                      </a>
                      <br /> to complete your booking
                      <br />
                      your basket ID is: 
                      <b>{localStorage.getItem("basketID")}</b>
                    </div>
                  ) : loadPayment()}
                </Col>
                <Col xs={12} md={6} className="payment-table-summary">
                  <Panel
                    className="outbound-panel"
                  >
                             
                    <Panel.Heading>
                      <h4 >
                        <strong>Outbound Transfer</strong>
                      </h4>
                    </Panel.Heading>
                    <ListGroup fill>
                      <ListGroupItem className='main-list-item' >
                        
                              <span>{outboundData.fromDestination.name}</span>
                        
                              <div className="fromTo" >&gt;</div>                        
                            <span>{outboundData.toDestination.name}</span>
                         
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Departing Date</Col>
                          <Col xs={6}>
                            {moment(outboundData.date).format("Do MMMM YYYY")}
                          </Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Flight Time</Col>
                          <Col xs={6}>{outboundData.time}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Adults</Col>
                          <Col xs={6}>{outboundData.adults}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Children</Col>
                          <Col xs={6}>{outboundData.children.length}</Col>
                        </Row>
                      </ListGroupItem>
                   
                    </ListGroup>
                  </Panel>
                  {inboundData ? (
                    <Panel
                      className="inbound-panel"
                    >
                      <Panel.Heading >
                        <h4>
                          <strong>Return Transfer</strong>
                        </h4>
                      </Panel.Heading>
                      <ListGroup  >
                        <ListGroupItem className='main-list-item' >
                        
                        <span>{inboundData.fromDestination.name}</span>
                  
                        <div className="fromTo" >&gt;</div>                  
                      <span>{inboundData.toDestination.name}</span>
                   
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Departing Date</Col>
                            <Col xs={6}>
                              {moment(inboundData.date).format("Do MMMM YYYY")}
                            </Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Flight Time</Col>
                            <Col xs={6}>{inboundData.time}</Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Adults</Col>
                            <Col xs={6}>{inboundData.adults}</Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Children</Col>
                            <Col xs={6}>{inboundData.children.length}</Col>
                          </Row>
                        </ListGroupItem>
                    
                      </ListGroup>
                    </Panel>
                  ) : null}
                      <div className="change-options">
              <a href="/quote/return" className="btn btn-success"><span>Change my options</span></a>
          </div>
                </Col>
            
              </Panel.Body>
            </Panel>
          </Col>
        </Grid>
      </div>
    );
  }
}

export default connect(
  state => ({
    recordPaymentSuccess: state.payment.recordPayment.recordPaymentSuccess
  }),
  { recordPayment }
)(PersonalDetails);



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/PersonalDetails/index.js